import { all, put, call, takeEvery } from 'redux-saga/effects';
import { fetchArtAuthor, fetchArtAuthorSuccess } from './actions';
import { requestPuppy } from '@wix/da-http-client/pkg/request';
export function fakeResponse(options) {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line
        const users = require('@wix/da-sample-data').users;
        const randomUser = users[Math.round(Math.random() * (users.length - 1))];
        return {
            user: randomUser
        };
    }
}
function* fetchAuthor(action) {
    const { username } = action.payload;
    const response = yield call(requestPuppy, {
        method: 'get',
        url: 'user/info',
        params: {
            username
        }
    }, fakeResponse);
    if (response && response.user) {
        yield put(fetchArtAuthorSuccess({
            user: response.user
        }));
    }
}
export default function* saga() {
    yield all([
        takeEvery(fetchArtAuthor, fetchAuthor)
    ]);
}
